import { useState } from "react";
import {
  Button,
  Container,
  Group,
  NumberInput,
  Stack,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useLocation } from "wouter";
import { createPartnerMerchant } from "../api";

export default function PartnerMerchantCreate() {
  const [saving, setSaving] = useState(false);
  const [, setLocation] = useLocation();
  const form = useForm({
    initialValues: {
      tenantName: "",
      email: "",
      firstName: "",
      lastName: "",
      skuCount: 0,
    },
  });

  return (
    <Container size="sm">
      <Title order={1} mb="lg">
        Create Merchant
      </Title>
      <form
        onSubmit={form.onSubmit(async (values) => {
          setSaving(true);
          try {
            await createPartnerMerchant(values);
            notifications.show({
              title: "Tenant created",
              message: "An activation email was sent to the owner.",
              color: "green",
            });
            setLocation("/partner/merchants");
          } catch (error) {
            const message = String(error?.message || error);
            if (/already exists/i.test(message)) {
              form.setFieldError(
                "email",
                "A user with that email already exists.",
              );
            }
          } finally {
            setSaving(false);
          }
        })}
      >
        <Stack>
          <TextInput
            label="Tenant name"
            required
            {...form.getInputProps("tenantName")}
          />
          <TextInput
            label="Owner email"
            required
            type="email"
            {...form.getInputProps("email")}
          />
          <TextInput label="First name" {...form.getInputProps("firstName")} />
          <TextInput label="Last name" {...form.getInputProps("lastName")} />
          <NumberInput
            label="SKUs to grant now"
            description="Taken from your pool. 0 to create the tenant with no credits."
            min={0}
            {...form.getInputProps("skuCount")}
          />
          <Group justify="space-between">
            <Button
              variant="subtle"
              onClick={() => setLocation("/partner/merchants")}
            >
              Back
            </Button>
            <Button type="submit" loading={saving}>
              Create
            </Button>
          </Group>
        </Stack>
      </form>
    </Container>
  );
}
